<template>
  <v-navigation-drawer
    v-if="!$store.state.calculationFullscreen"
    :width="$store.state.desktop ? 240 : 92"
    class="drawer d-flex align-center pt-4 py-lg-0"
    :rail="$store.state.desktop ? rail : false"
    :rail-width="$store.state.desktop ? 92 : undefined"
    :style="$store.state.desktop ? '' : { bottom: '80px', paddingBottom: '16px' }"
    :location
  >
    <v-list-item class="mt-4 ms-2 d-none d-lg-flex" @click="rail = !rail">
      <template v-slot:prepend>
        <div>
          <img v-show="rail" :src="require('@/assets/logo-mini.svg')" width="52" height="50" />
          <img v-show="!rail" :src="require('@/assets/logo.svg')" width="187" height="50" />
        </div>
      </template>
    </v-list-item>

    <v-list-item class="d-lg-flex justify-center pa-0 d-none">
      <template v-slot:prepend>
        <div>
          <img v-show="rail" :src="require('@/assets/divider-mini.svg')" width="80" height="2" />
          <img v-show="!rail" :src="require('@/assets/divider.svg')" width="224" height="2" />
          <v-btn
            icon
            dark
            @click="rail = !rail"
            v-show="rail"
            class="mt-1 arrow"
            :style="rtl ? 'right: 80px;' : 'left: 80px;'"
          >
            <img
              :src="rtl ? require('@/assets/arrow-left.svg') : require('@/assets/arrow-right.svg')"
              width="7"
              height="12"
            />
          </v-btn>
          <v-btn
            icon
            dark
            @click="rail = !rail"
            v-show="!rail"
            class="mt-1 arrow-active"
            :style="rtl ? 'right: 228px;' : 'left: 228px;'"
          >
            <img
              :src="rtl ? require('@/assets/arrow-right.svg') : require('@/assets/arrow-left.svg')"
              width="7"
              height="12"
            />
          </v-btn>
        </div>
      </template>
    </v-list-item>

    <div class="d-flex flex-lg-column overflow-x-auto">
      <router-link
        v-for="(menu, index) in menus"
        :to="menu.to"
        :key="index"
        v-slot="{ isActive }"
        style="text-decoration: none; color: inherit"
        :disabled="menu.disabled"
        class="my-lg-2 mx-lg-3"
      >
        <v-list-item
          :class="isActive && !menu.disabled ? 'menu-active' : 'menu'"
          height="48"
          :width="rail ? ($store.state.desktop ? 64 : 58) : undefined"
          :disabled="menu.disabled"
          :tour="menu.to"
          class="d-flex justify-center rounded-lg"
        >
          <template v-slot:prepend>
            <div
              :class="isActive && !menu.disabled ? 'icon-active' : 'icon'"
              class="d-flex flex-row justify-center w-100 mx-auto"
            >
              <img
                :src="
                  isActive && !menu.disabled
                    ? require(`@/assets/${menu.icon}-active.svg`)
                    : require(`@/assets/${menu.icon}.svg`)
                "
                width="16"
                height="16"
              />
            </div>
          </template>
          <v-sheet class="ms-4 flex-nowrap d-lg-flex flex-grow-0 d-none" width="200" color="transparent">
            {{ menu.text }}
          </v-sheet>
        </v-list-item>
      </router-link>
    </div>

    <div class="d-none d-lg-flex flex-lg-column">
      <v-card
        class="mx-4 mt-lg-4 plan border-sm mb-4"
        style="border: 1px #98a1b0 solid"
        @click="$store.state.upgradeGain = true"
        v-if="is_factory && (Object.keys(factory_info).length && !factory_info.plan ? true : false)"
      >
        <v-list-item>
          <div class="d-flex justify-center flex-column">
            <div class="mx-auto mt-2">
              <img :src="require('@/assets/crown.svg')" width="24" height="24" />
            </div>
            <div class="ms-3 flex-nowrap d-flex text-N80 mt-4" v-if="!rail">
              {{ $t('running_assets_free_plan_upgrade_without_limit') }}
            </div>
            <v-btn
              v-if="!rail"
              variant="outlined"
              color="N80"
              class="my-4 text-capitalize"
              @click="$store.state.upgradeGain = true"
            >
              {{ $t('view_plans') }}
            </v-btn>
          </div>
        </v-list-item>
      </v-card>

      <v-list-item @click="viewCompany" class="mx-auto w-100" style="border-radius: 8px" v-if="is_factory || is_buyer">
        <template v-slot:prepend>
          <div class="d-flex flex-row justify-center w-100 my-lg-2 mx-lg-3">
            <img
              v-if="factory_info.factory_logo"
              :src="factory_info.factory_logo"
              width="32"
              height="32"
              style="border-radius: 8px"
            />
            <img
              v-else
              :src="require('@/assets/logo-thumbnail.svg')"
              width="32"
              height="32"
              class="pa-1"
              style="border-radius: 8px; border: 2px solid white"
            />
          </div>
        </template>
        <v-sheet class="ms-4 flex-nowrap d-lg-flex flex-grow-0 d-none text-white" width="200" color="transparent">
          {{ factory_info.name }}
        </v-sheet>
        <!-- <div class="d-flex align-center">
          <div
            class="text-N40 ms-4"
          >
            {{ factory_info.name }}
          </div>
          <v-spacer />
          <v-btn
              icon
              size="x-small"
              style="background: #292f39"
          >
            <img :src="require('@/assets/more.svg')" width="24" height="24">
          </v-btn>
        </div>  -->
      </v-list-item>

      <div class="px-2 w-100 mx-auto mt-4">
        <v-select
          lable="language"
          :items="langs"
          density="compact"
          variant="outlined"
          :model-value="lang"
          @update:model-value="changeLang"
          class="text-white text-truncate"
        ></v-select>
      </div>
    </div>

    <UpgradeGain></UpgradeGain>
  </v-navigation-drawer>
</template>

<script>
import { defaultLocale, languages } from '@/locales'
import UpgradeGain from '@/views/Dashboard/Reports/dialog/UpgradeGain'
import jwtDecode from 'jwt-decode'

export default {
  name: 'SideBar',
  props: {
    factory_info: {
      type: Object,
      default: {},
    },
  },
  components: { UpgradeGain },
  computed: {
    menus() {
      let user_info = jwtDecode(localStorage.getItem('access')).user_info
      if (user_info.is_admin) {
        return [
          { text: this.$t('dashboard'), icon: 'leader', to: '/reports' },
          { text: this.$t('factory_and_setup'), icon: 'building', to: '/factory' },
          { text: this.$t('order_management'), icon: 'process', to: '/orders' },
          { text: this.$t('tools'), icon: 'note', to: '/request' },
          { text: this.$t('operators'), icon: 'profile2user', to: '/team-operator' },
        ]
      } else if (user_info.is_verify_operator) {
        return [
          { text: this.$t('dashboard'), icon: 'leader', to: '/operator' },
          { text: this.$t('tools'), icon: 'note', to: '/operator/report' },
          { text: this.$t('leader_board'), icon: 'ranking', to: '/operator/leader' },
        ]
      } else if (user_info.is_verify_operator === null && user_info.is_admin === null && user_info.is_supplier) {
        return [{ text: this.$t('dashboard'), icon: 'building', to: '/supplier' }]
      } else if (user_info.is_buyer) {
        return [{ text: this.$t('dashboard'), icon: 'leader', to: '/buyer' }]
      }
    },
    location() {
      if (this.$store.state.desktop) {
        if (localStorage.getItem('lang') === 'fa') {
          return 'right'
        }
        return 'left'
      }
      return 'bottom'
    },
    rtl() {
      return localStorage.getItem('lang') === 'fa' || false
    },
    is_factory() {
      let user_info = jwtDecode(localStorage.getItem('access')).user_info
      return user_info.is_admin || user_info.is_verify_operator
    },
    is_buyer() {
      let user_info = jwtDecode(localStorage.getItem('access')).user_info
      return user_info.is_buyer
    },
    langs() {
      return Object.keys(languages)
    },
  },
  data: () => ({
    rail: true,
    lang: null,
  }),
  beforeMount() {
    this.lang = localStorage.getItem('lang') || defaultLocale
  },
  methods: {
    viewCompany() {
      this.$store.state.setting = 'workspace'
      this.$store.state.editProfile = true
    },
    changeLang(event) {
      localStorage.setItem('lang', event)
      if (this.lang !== event) {
        this.$router.go()
      }
    },
  },
}
</script>

<style>
.drawer {
  background:
    radial-gradient(151.88% 64.7% at 0% 35.3%, rgba(83, 83, 83, 0.64) 0.55%, rgba(0, 0, 0, 0.64) 100%)
      /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */,
    #354764;
  box-shadow: 0px 10px 17px rgba(54, 64, 102, 0.35);
}
.plan {
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(2px);
  border-radius: 8px;
}
.icon {
  padding: 8px;
  background: linear-gradient(132.25deg, rgba(255, 255, 255, 0.15) -17.8%, rgba(255, 255, 255, 0) 109.28%);
  backdrop-filter: blur(4px);

  border-radius: 8px;
}
.icon-active {
  padding: 8px;
  background: #a3a3ff;
  border-radius: 8px;
}
.menu {
  color: #dfe2e6;
}
.menu-active {
  background: #ffffff;
  border-radius: 8px;
  color: #243757;
}
.profile {
  padding: 8px 0px;
  gap: 10px;
  margin: 24px 24px 0 14px;
  height: 155px;
  background: linear-gradient(132.25deg, rgba(255, 255, 255, 0.15) -17.8%, rgba(255, 255, 255, 0) 109.28%);
  backdrop-filter: blur(4px);
  border-radius: 8px;
}
.arrow {
  position: fixed;
  top: 76px;
  z-index: 10000;
  box-sizing: border-box;

  width: 24px !important;
  height: 24px !important;

  background:
    radial-gradient(151.88% 64.7% at 0% 35.3%, rgba(83, 83, 83, 0.64) 0.55%, rgba(0, 0, 0, 0.64) 100%)
      /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */,
    #354764;
  backdrop-filter: blur(180px);

  border-radius: 24px;
}
.arrow-active {
  position: fixed;
  top: 76px;
  z-index: 2000;
  box-sizing: border-box;

  width: 24px !important;
  height: 24px !important;

  background:
    radial-gradient(151.88% 64.7% at 0% 35.3%, rgba(83, 83, 83, 0.64) 0.55%, rgba(0, 0, 0, 0.64) 100%)
      /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */,
    #354764;
  backdrop-filter: blur(180px);

  border-radius: 24px;
}
</style>
